<template>
 <div>
   <freight-web-component 
   :tool.prop="{...tool}" 
   :user="user && user.uid" 
   :focus.prop="{...focus}"
   :set-tracker.prop="(p,c) => uploadImage(p,c)"
   :set-setting.prop="(p) => $store.dispatch('tools/addFreightSetting', p)"
    >
      <template v-if="showTracking" v-slot:default>
        THIS IS TRACKING
      </template>
   </freight-web-component>
  </div>
</template>

<script>

import Vue from "vue"
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
import firebase from "firebase";
const FilePond = vueFilePond(FilePondPluginFileValidateType,FilePondPluginImagePreview);

window.Vue = Vue
window.FilePond = {
  FilePond,
}
const FreightWebComponent = () => import("./wc/freight-web-component")

Vue.use(FreightWebComponent)

export default {
  name: 'freight-component',
  components: {
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    user: {
      type: Object,
      required: false,
      default: () => {}
    },
    typeaheadApps: {
      type: Array,
      default: () => ['Maps','Calculator']
    },
    idprop: {
      type: String
    },
    showTracking: {
      type: Boolean
    }
  },
  methods:{
    uploadImage(p,code) {
      //  let files = (this.$refs.toUpload.getFiles())
      //  this.getBase64(files[0].file).then((imgDataUrl) => {
       this.getBase64(p).then((imgDataUrl) => {
         var storageRef = firebase.storage().ref(`freight_img/${this.user.uid}/${code}`);
 
         var metadata = {
           contentType: 'image/jpeg',
         };
         var uploadTask = storageRef.putString(imgDataUrl, 'data_url');
 
         uploadTask.on('state_changed', (snapshot) => {
           switch (snapshot.state) {
             case firebase.storage.TaskState.PAUSED: // or 'paused'
               console.log('Upload is paused');
               break;
             case firebase.storage.TaskState.RUNNING: // or 'running'
               console.log('Upload is running');
               break;
           }
         }, (error) => {
           console.log("Error uploading image: ", error)
         }, () => {
           uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            //  this.$store.dispatch("user/updateProfile", {imgURL: downloadURL})
            //  .then(() => {
               let track = {
                 _created_at: new Date(),
                 imgURL: downloadURL,
                 code
               }
               this.$store.dispatch('tools/addTrackIntoFreightTool', {track, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
               .then(() => {
                 console.log("successfully upload image")
                 })
            //  })
           });
         });
       })
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
  },
  computed: {
  },
  data: function() {
    return {
    }
  },
  mounted(){
  }
}
</script>
<style lang="scss" module>
  @import './style.module.scss';
</style>
<style scoped>
  .notepad {
    background-color: rgb(255, 242, 204);
    border-radius: 5px;
    width: 100%;
    height: 125px;
  }
  .card-body {
    overflow-y: auto;
  }
</style>
